import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';
import LoadingOverlay from 'react-loading-overlay';
import Select from 'react-select';

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  const fileInputRef = useRef(null);
  const passwordFileInputRef = useRef(null);

  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [uploadPasswordFile, setUploadPasswordFile] = useState<File | null>(null);

  const companyRef = useRef(null);
  const [companyIds, setCompanyIds] = useState([]);
  const [companies, setCompanies] = useState([]);

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadMessage, setUploadMessage] = useState<Array<string>>([]);
  const [passwordUploadMessage, setPasswordUploadMessage] = useState<Array<string>>([]);

  // ロード系
  const [isLoading, setIsLoading]  = useState<Boolean>(false);

  // 初期ロード
  useEffect(() =>{
    setIsLoading(true);
    searchCompanies();
    setIsLoading(false);
  }, []);


  function searchCompanies(){
    axios.get(
      '/api/internal/certificates/select_company_list')
    .then(function (response) {
      setCompanies(response.data.m_companies);
    }).catch(error => {
      setErrorMessage(error.response.data.message);
    }).finally(() => {
    });
  }

  const selectFile = (e) => {
    const files = e.target.files
    if(files && files[0]){
      setUploadFile(files[0]);
    }
  }

  const selectPasswordFile = (e) => {
    const files = e.target.files
    if(files && files[0]){
      setUploadPasswordFile(files[0]);
    }
  }

  const fileUpload = () => {
    fileInputRef.current.click();
  }

  const passwordFileUpload = () => {
    passwordFileInputRef.current.click();
  }

  const submitCertificateUpload = async() => {
    setIsLoading(true);
    initStates();
    const file_data = await createFormDate(uploadFile);
    axios.post(
      '/api/internal/certificates/upload', file_data, { headers: {'content-type': 'multipart/form-data'}})
    .then(function (response) {
      searchCompanies();
      setUploadFile(null);
      setUploadMessage(response.data.messages.join('\n'));
    }).catch(error => {
      setErrorMessage(error.response.data.message);
      window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }).finally(() => {
      setIsLoading(false);
    });
  }

  const submitCertificatePasswordUpload = async() => {
    setIsLoading(true);
    initStates();
    const file_data = await createFormDate(uploadPasswordFile);
    axios.post(
      '/api/internal/companies/import_certificate_password', file_data, { headers: {'content-type': 'multipart/form-data'}})
    .then(function (response) {
      searchCompanies();
      setUploadPasswordFile(null);
      setPasswordUploadMessage(response.data.messages.join('\n'));
    }).catch(error => {
      setErrorMessage(error.response.data.message);
      window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }).finally(() => {
      setIsLoading(false);
    });
  }

  const submitCertificateMail = async() => {
    setIsLoading(true);
    initStates();
    axios.post(
      '/api/internal/certificates/company_send_mails', {company_ids: companyIds})
    .then(function (response) {
      companyRef.current.clearValue();
      setCompanyIds([]);
      setSuccessMessage("証明書の案内メール一括送信が完了しました。");
    }).catch(error => {
      setErrorMessage(error.response.data.message);
    }).finally(() => {
      window.scrollTo({left: 0, top: 0, behavior: "smooth"});
      setIsLoading(false);
    });
  }

  const createFormDate = (file) => {
    const upload_file = new FormData();
    upload_file.append('certificate[file]', file);

    return upload_file
  }

  const onChangeCompanyIds = (values) => {
    setCompanyIds(values.map(value => value["value"]));
  }

  function initStates() {
    setErrorMessage("");
    setSuccessMessage("");
    setUploadMessage([]);
  }

  return(
    <LoadingOverlay active={isLoading} spinner text="Loading...">
      { successMessage &&
        <div className="alert fade in alert-success ">
          <button type="button" className="close" data-dismiss="alert">×</button>
          {successMessage}
        </div>
      }
      { errorMessage &&
        <div className="alert alert-danger alert-dismissible" role="alert">
          <button type="button" className="close" data-dismiss="alert" aria-label="閉じる">
            <span aria-hidden="true">×</span>
          </button>
          { errorMessage }
        </div>
      }
      <h3>証明書一括アップロード</h3>
      <br/>
      {
        uploadMessage.length != 0 &&
        <div className="form-group">
          <label htmlFor="upload_message">アップロードログ</label>
          <textarea disabled={true} className="form-control" rows={10} id="upload_message" value={uploadMessage}/>
        </div>
      }

      <div className="form-group">
        <label>ファイルアップロード</label><span className="label label-danger ml5">必須</span>
          <div className="form-inline">
            <div className="felx_center">
              <div className="col-md-8">
                { uploadFile ? uploadFile.name : "ファイルを選択してください"}
              </div>
                <div className="col-md-4">
                  <button className="btn btn-info" name="button" type="button" onClick={fileUpload}>ファイルを選択</button>
                  <input className="display-none" ref={fileInputRef} id="upload_file" type="file" accept=".zip" onChange={selectFile}/>
                </div>
            </div>
          </div>
      </div>
      <br/>
      <div className="actions text-center">
        <button disabled={!uploadFile} className="btn btn-primary m5" data-toggle="modal" data-target="#certificates_upload_modal">
          アップロードする
        </button>
      </div>
      <hr/>
      <h3>証明書パスワード一括登録</h3>
      <br/>
      {
        passwordUploadMessage.length != 0 &&
        <div className="form-group">
          <label htmlFor="password_upload_message">アップロードログ</label>
          <textarea disabled={true} className="form-control" rows={10} id="password_upload_message" value={passwordUploadMessage}/>
        </div>
      }
      <div className="form-group">
        <label>ファイルアップロード</label><span className="label label-danger ml5">必須</span>
          <div className="form-inline">
            <div className="felx_center">
              <div className="col-md-8">
                { uploadPasswordFile ? uploadPasswordFile.name : "ファイルを選択してください"}
              </div>
                <div className="col-md-4">
                  <button className="btn btn-info" name="button" type="button" onClick={passwordFileUpload}>ファイルを選択</button>
                  <input className="display-none" ref={passwordFileInputRef} id="upload_password_file" type="file" accept=".csv" onChange={selectPasswordFile}/>
                </div>
            </div>
          </div>
      </div>
      <br/>
      <div className="actions text-center">
        <button disabled={!uploadPasswordFile} className="btn btn-primary m5" data-toggle="modal" data-target="#certificates_password_modal">
          アップロードする
        </button>
      </div>
      <hr/>
      <h3>証明書案内メール一括送信</h3>
      <br/>
      <div className="form-group">
        <label>企業名</label><span className="label label-danger ml5">必須</span>
        <Select
          ref={companyRef}
          isMulti
          onChange={onChangeCompanyIds}
          options={companies}
          className="basic-multi-select"
          classNamePrefix="select"
          placeholder="選択してください"
        />
      </div>
      <div className="actions text-center">
        <button disabled={companyIds.length === 0} className="btn btn-primary m5" data-toggle="modal" data-target="#certificates_mail_modal">
          送信する
        </button>
      </div>

      {/* アップロード */}
      <div className="modal fade" data-backdrop="static" id="certificates_upload_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
          <div className="sw-modal-icon-question sw-modal-icon">?</div>
          <h2>アップロードする</h2>
          <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
          　証明書をアップロードします
            <br />
            よろしいですか？<br />
          </div>
          <a type="button"
              className="sw-modal-btn"
              style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
              data-dismiss="modal"
              onClick={ submitCertificateUpload }
          >
          アップロード
          </a>
          <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
        </div>
        </div>
      </div>

      {/* パスワードアップロード */}
      <div className="modal fade" data-backdrop="static" id="certificates_password_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
          <div className="sw-modal-icon-question sw-modal-icon">?</div>
          <h2>一括登録する</h2>
          <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
          　証明書パスワードの一括登録をします
            <br />
            よろしいですか？<br />
          </div>
          <a type="button"
              className="sw-modal-btn"
              style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
              data-dismiss="modal"
              onClick={ submitCertificatePasswordUpload }
          >
          アップロード
          </a>
          <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
        </div>
        </div>
      </div>

      {/* メール確認 */}
      <div className="modal fade" data-backdrop="static" id="certificates_mail_modal">
        <div className="sw-modal-content">
        <div className="sw-modal-dialog" style={{ minHeight: '363px'}}>
          <div className="sw-modal-icon-question sw-modal-icon">?</div>
          <h2>証明書メール送信</h2>
          <div className="sw-modal-body" style={{ marginBottom: '50px'}}>
          　{companyIds.length}企業にメールを送信します
            <br />
            よろしいですか？<br />
          </div>
          <a type="button"
              className="sw-modal-btn"
              style={{ backgroundColor: '#3071a9', textDecoration: 'none'}}
              data-dismiss="modal"
              onClick={ submitCertificateMail }
          >
          送信する
          </a>
          <button type="button" className="sw-modal-btn" data-dismiss="modal">キャンセル</button>
        </div>
        </div>
      </div>

    </LoadingOverlay>
    )
}
export default Index;